// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"540":"7afbb1ef","566":"45692589"}[chunkId] + ".chunk.css";
};